import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';

import { standardWeight_Stringer } from '../../../lib/data/standard-weight';

const StringerForm = ({ onSaveStructure, onChangeWeightSummary, stringers, beltWidth }) => {
    const [isShow, setIsShow] = useState(stringers?.length || false);
    const [newStringer, setNewStringer] = useState(stringers || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [densityCategory, setDensityCategory] = useState('');
    const [length, setLength] = useState('');
    const [standardWeight, setStandardWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalLength, setTotalLength] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /* standard weight library에서 해당 벨트폭을 뽑아서 저장한다. */
    const weightLibrary = useRef(null); // chatGPT가 알려준 내용

    /* category 설명하는 text */
    const densityCategoryText = useRef({
        0: '1.0 이하',
        1: '1.0초과 2.0이하',
        2: '2.0 초과',
    });

    /*  처음 props로 넘어온 stringers를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialStringer = useRef(stringers || []);

    /* 벨트폭에 해당하는 Weight Table을 가져온다. */
    useEffect(() => {
        if (!standardWeight_Stringer || !beltWidth) return;
        const library = standardWeight_Stringer.find((item) => item.beltWidth === parseInt(beltWidth));
        if (!library) {
            alert('Check Belt Width!!');
            return;
        }
        weightLibrary.current = library;
    }, [beltWidth]);

    /* 기준 중량 가져오기 함수 */
    const getStandardWeight = useCallback((densityCategory) => {
        if (!weightLibrary.current) return;

        const index = densityCategory * 1;
        return weightLibrary.current.standardWeight[index];
    }, []);

    /* 기준 중량 가져오기 */
    useEffect(() => {
        if (!densityCategory) return;
        setStandardWeight(getStandardWeight(Number(densityCategory)));
    }, [densityCategory, getStandardWeight]);

    /* 단위 중량 및 중량 자동 계산 */
    useEffect(() => {
        // if (!length || !standardWeight || !factor) {
        //     return;
        // }
        const _weight = Math.ceil(length * standardWeight * factor);
        setWeight(_weight);
    }, [factor, length, standardWeight]);

    /* 마지막 stringer ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newStringer.length) {
            return 0;
        }
        return Math.max(...newStringer.map((stringer) => Number(stringer.id.substring(3))), 0);
    }, [newStringer]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`ST-${getLastId() * 1 + 1}`);
        // setDensityCategory('');
        // setStandardWeight('');
        // setFactor('');
        setLength('');
        setWeight('');
    }, [getLastId]);

    /* 전체 길이 계산 함수 */
    const getTotalLength = useCallback((items) => {
        const _totalLength = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.length);
        }, 0);
        setTotalLength(_totalLength);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newStringer에 stringer 추가 */
    const onAddStringer = useCallback(() => {
        if (!length || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const stringer = {
            id,
            densityCategory: densityCategoryText.current[`${densityCategory}`],
            standardWeight,
            factor,
            length,
            weight,
        };
        setNewStringer((prev) => [...prev, stringer]);
        setIsChanged(true);
    }, [id, densityCategory, standardWeight, factor, length, weight]);

    /* 삭제 버튼을 누르면 해당 stringer 삭제 */
    const onDeleteStringer = useCallback((id) => {
        setNewStringer((prev) => prev.filter((stringer) => stringer.id !== id));
        setIsChanged(true);
    }, []);

    /* newStringer에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalLength(newStringer);
        getTotalWeight(newStringer);
        initializeForm();
        onSaveStructure({
            key: 'stringer',
            value: newStringer,
        });
        onChangeWeightSummary({
            key: 'stringer',
            value: {
                totalLength,
                totalWeight,
            },
        });
    }, [
        getTotalLength,
        getTotalWeight,
        initializeForm,
        newStringer,
        onChangeWeightSummary,
        onSaveStructure,
        totalLength,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveStringer = useCallback(() => {
    //     onSaveStructure({
    //         key: 'stringer',
    //         value: newStringer,
    //     });
    //     onChangeWeightSummary({
    //         key: 'stringer',
    //         value: {
    //             totalLength,
    //             totalWeight,
    //         },
    //     });
    // }, [newStringer, onChangeWeightSummary, onSaveStructure, totalLength, totalWeight]);

    /* 변경 사항을 취소하면 newStringer를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewStringer(initialStringer.current);
    //     onSaveStructure({
    //         key: 'stringer',
    //         value: initialStringer.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'stringer',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <StringerFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Stringer</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalLength} m</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>
                                    Density <br />
                                    Category
                                </th>
                                <th>
                                    Standard W't <br />
                                    (kg/m)
                                </th>
                                <th>Factor</th>
                                <th>
                                    Length <br /> (m)
                                </th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newStringer &&
                                newStringer.map((stringer, index) => (
                                    <tr key={index}>
                                        <td>{stringer.id}</td>
                                        <td>{stringer.densityCategory}</td>
                                        <td>{stringer.standardWeight}</td>
                                        <td>{stringer.factor}</td>
                                        <td>{stringer.length}</td>
                                        <td>{stringer.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteStringer(stringer.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td>
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="densityCategory"
                                                value="0"
                                                onChange={(e) => setDensityCategory(e.target.value)}
                                            />
                                            <span>γ ≤ 1</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="densityCategory"
                                                value="1"
                                                onChange={(e) => setDensityCategory(e.target.value)}
                                            />
                                            <span>1 ＜ γ ≤ 2</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="densityCategory"
                                                value="2"
                                                onChange={(e) => setDensityCategory(e.target.value)}
                                            />
                                            <span>2 ＜ γ </span>
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={standardWeight}
                                        onChange={(e) => setStandardWeight(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={length}
                                        onChange={(e) => setLength(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddStringer}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={4}>Stringer Total</td>
                                <td>{totalLength}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveStringer} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </StringerFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const StringerFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .td-radio {
        display: flex;
        justify-content: center;
        // margin: 0 auto;
    }
    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 auto;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.25rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
    .right-align {
        text-align: right;
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default StringerForm;
